import { Badge, Card, CardBody, Col } from "reactstrap";
import CommonCardHeader from "../../../../Common/CommonCardHeader";
import { BadgesScrollbars } from "../../../../Constant";
import ScrollBar from "react-perfect-scrollbar";
import { LI, OL } from "../../../../AbstractElements";
import { BADGE_SCROLL, BADGE_SCROLL_LIST } from "../../../../Data/Bonus Ui/Scrollable";

const BadgesScrollbar = () => {
  return (
    <Col xl="4" md="6">
      <Card>
        <CommonCardHeader title={BadgesScrollbars} span={BADGE_SCROLL} />
        <CardBody>
          <ScrollBar className="scroll-demo" style={{ width: "100%", height: "300px" }}>
            <OL className="list-group list-group-numbered scroll-rtl">
              <LI className="d-flex align-items-start flex-wrap">
                <div className="ms-2 me-auto">Stella Nowland</div>
                <Badge pill color="warning" className="p-2">Freelance</Badge>
              </LI>
              {BADGE_SCROLL_LIST.map(({ title, color, text }, index) => (
                <LI className="d-flex align-items-start flex-wrap" key={index}>
                  <div className="ms-2 me-auto">{title}</div>
                  <Badge color={color} pill className="p-2">{text}</Badge>
                </LI>
              ))}
            </OL>
          </ScrollBar>
        </CardBody>
      </Card>
    </Col>
  );
};

export default BadgesScrollbar;
